import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/** Represents the header area of the conversation view. */
export const ConversationHeader = () => {
    return _jsx(_Fragment, { children: "conversation header" });
};
